import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconDotsVertical, IconSettings, IconX } from '@tabler/icons-react';
import { Box } from 'src/design/atoms/Box';
import { Divider } from 'src/design/atoms/Divider';
import { Group } from 'src/design/atoms/Group';
import { Stack } from 'src/design/atoms/Stack';
import { UnstyledButton } from 'src/design/atoms/UnstyledButton';
import { BasicActionIcon } from 'src/design/atoms/BasicActionIcon';
import { Popover } from 'src/design/molecules/Popover';
import { Profile } from 'src/app/navigation/Profile';

export interface IMobileSectionProps {
  settingsRoute?: string;
}

/** @registry Mobile header overflow menu: collapses settings link + Profile behind a single popover to save nav-row width. */
export const MobileSection: React.FC<IMobileSectionProps> = ({
  settingsRoute,
}) => {
  const [opened, setOpened] = useState(false);
  const navigate = useNavigate();

  const handleSettings = () => {
    if (!settingsRoute) return;
    setOpened(false);
    navigate(settingsRoute);
  };

  return (
    <Box style={{ flexShrink: 0, marginLeft: 6 }}>
      <Popover
        opened={opened}
        onChange={setOpened}
        position="bottom-end"
        offset={9}
        shadow="md"
        zIndex={201}
      >
        <Popover.Target>
          <BasicActionIcon
            variant="subtle"
            color="dark"
            size="lg"
            bg={opened ? 'gray.3' : 'gray.1'}
            onClick={() => setOpened((o) => !o)}
            aria-label="Open header menu"
          >
            <IconDotsVertical />
          </BasicActionIcon>
        </Popover.Target>

        <Popover.Dropdown p="xs">
          <Stack gap={4} miw={200}>
            <Group justify="flex-end">
              <BasicActionIcon
                variant="subtle"
                color="dark"
                size="sm"
                onClick={() => setOpened(false)}
                aria-label="Close header menu"
              >
                <IconX size={16} />
              </BasicActionIcon>
            </Group>
            {settingsRoute && (
              <>
                <UnstyledButton
                  onClick={handleSettings}
                  px="sm"
                  py="xs"
                  style={{ borderRadius: 4 }}
                >
                  <Group gap="sm">
                    <IconSettings size={18} />
                    <span>Settings</span>
                  </Group>
                </UnstyledButton>
                <Divider />
              </>
            )}
            <Profile />
          </Stack>
        </Popover.Dropdown>
      </Popover>
    </Box>
  );
};
